import { isValidUserGroup } from '@loc/helpers/src/userGroup/helpers/isValidUserGroup'

import { UserTag } from '../type'

export function getPlanGroupByUserGroup<
  T extends {
    [key: string]: {
      range: number[]
    }
  },
>({ userGroup, planGroupMapping }: { userGroup: string; planGroupMapping: T }) {
  if (!isValidUserGroup(userGroup)) {
    return UserTag.B
  }

  const userGroupNumber = +userGroup

  for (const key in planGroupMapping) {
    const _key = key as unknown as keyof typeof planGroupMapping
    const mapping = planGroupMapping[_key]
    const [min, max] = mapping.range
    if (userGroupNumber >= min && userGroupNumber <= max) {
      return _key
    }
  }

  return UserTag.B
}

/*
用于测试生成结果的函数
function generateRandomStats(numTrials) {
  function generateRandomBetween101And160() {
    return Math.floor(Math.random() * 60) + 101;
  }

  // 初始化一个记录生成次数的对象
  const counts = {};

  // 执行函数多次并统计每个数的出现次数
  for (let i = 0; i < numTrials; i++) {
    const randomNumber = generateRandomBetween101And160();
    if (counts[randomNumber]) {
      counts[randomNumber] += 1;  // 如果已有记录，增加次数
    } else {
      counts[randomNumber] = 1;   // 如果没有记录，初始化次数为1
    }
  }

  return counts;
}

// 记录并显示每个数字出现的次数
const resultCounts = generateRandomStats(1000);
console.log(resultCounts);
*/
